/**
 * @generated SignedSource<<45f584d660aa5ebc1ce68c6307a0e676>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4ConnectMenuItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4AppMenuItem">;
  readonly " $fragmentType": "Nav4ConnectMenuItem";
};
export type Nav4ConnectMenuItem$key = {
  readonly " $data"?: Nav4ConnectMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ConnectMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4ConnectMenuItem",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Nav4AppMenuItem"
    }
  ],
  "type": "JiraAppNavigationItem"
};

(node as any).hash = "76baf08d707245f4a5aadd384fd44056";

export default node;
